import { createContext, PropsWithChildren, useContext } from "react";

const LocaleContext = createContext("en");

/**
 * this should be replaced with new version of react-intl
 */
export function useLocale(): string {
    return useContext(LocaleContext);
}

export type LocaleProviderProps = {
    readonly locale: string;
};

export const LocaleProvider = ({
    locale,
    children
}: PropsWithChildren<LocaleProviderProps>) => {
    return (
        <LocaleContext.Provider value={locale}>
            {children}
        </LocaleContext.Provider>
    );
};
